import { get } from 'lodash';

export const getTraceIdentifier = error => get(error, 'graphQLErrors[0].extensions.data.traceIdentifier');
